export default __webpack_public_path__ + "static/media/slide-3-mob.bb6538c0.jpg";